import { takeEvery } from 'redux-saga/effects';

import authActions from 'store/actions/auth';
import { resetIdentity } from 'utils/addIdentity';

// Reset analytics identity on every logout. authActions.CLEAR ('AUTH/CLEAR') is
// the single point all logout paths funnel through (Okta logout, navigation /
// footer logout, and the 401 / token-refresh auto-logout interceptors), so
// watching it here guarantees Segment + Mixpanel identity is cleared exactly
// once per logout. Without this, Segment's cached traits would leak to the next
// user on the same browser.
function* watchResetAnalytics(): Generator {
  yield takeEvery(authActions.CLEAR, resetIdentity);
}

export default watchResetAnalytics;
